//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableServer from '../../components/Table/Table.vue'
import { formatTime, formatTrueFalse } from '../../components/helpers.js'

export default {
  name: 'RequestYandexExecutorJournal',
  components: {
    TableServer
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const columns = [{
      name: 'login',
      label: 'Логин исполнителя'
    }, {
      name: 'fio',
      label: 'ФИО исполнителя'
    }, {
      name: 'assignedEmployee',
      label: 'Пользователь учетной записи',
      format: value => value && value.name || ''
    }, {
      name: 'assignedEmployeeChanged',
      label: 'Пользователь учетной записи изменен',
      labelTable: 'Пользователь учетной</br>записи изменен',
      format: (value, record) => record._userAssigned || value ? formatTrueFalse(value) : ''
    }, {
      name: 'brigadeName',
      label: 'Бригада',
      format: (value, record) => record._userAssigned ? value : ''
    }, {
      name: 'brigadeChanged',
      label: 'Бригада изменена',
      format: (value, record) => record._userAssigned ? formatTrueFalse(value) : ''
    }, {
      name: 'brigadeEmployees',
      label: 'Состав бригады',
      format: (value, record) => {
        if (record._userAssigned && Array.isArray(value)) {
          return value.map(employee => employee.name || employee.fio).join(', ')
        }
        return ''
      }
    }, {
      name: 'brigadeEmployeesChanged',
      label: 'Состав бригады изменен',
      format: (value, record) => record._userAssigned ? formatTrueFalse(value) : ''
    }, {
      name: 'useState',
      label: 'Статус использования учетной записи',
      labelTable: 'Статус использования</br>учетной записи',
      format: value => value && value.name || ''
    }, {
      name: 'departureNumber',
      label: 'Номер выезда',
      format: (value, record) => record._userAssigned && value != null && value !== 0 ? value : ''
    }, {
      name: 'updateTime',
      label: 'Дата/время внесения записи',
      labelTable: 'Дата/время</br>внесения записи',
      format: formatTime
    }]

    for (const column of columns) {
      if (column.field == null) {
        column.field = column.name
      }
      if (column.align == null) {
        column.align = 'left'
      }
      if (column.sortable == null) {
        column.sortable = false
      }
    }

    return {
      columns: columns,
      pagination: {
        rowsPerPage: 0
      }
    }
  },
  computed: {
    itemsToShow: function () {
      return this.value || []
    }
  },
  methods: {
    getTrStyle: function (row) {
      return ''
    }
  }
}

